<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Brands / Company</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-brand">
            <v-icon left dark>mdi-plus</v-icon>New Brand
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="5" md="5">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="brands"
              :search="search"
            >
             <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/brand/${item.id}`" icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- delete template -->
              <template v-slot:item.deleteBrand="{ item }">
                <v-btn color="red" text @click="openDeleteModal(item)">
                  <v-icon left>mdi-close</v-icon> Delete
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- delete dialog modal -->
    <v-dialog v-model="deleteDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Delete Brand</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="deleteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row class="text--primary subtitle-2">
              <v-col cols="12">
                Are you sure you want to delete this brand?
              </v-col>
              <v-col cols="12">
                <span style="font-size: 20px">{{ brandItem.Name }}</span>
              </v-col>
              <v-col cols="12">
                <v-btn color="red" dark :loading="loader" @click="deleteBrand">Yes, Delete</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal -->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    deleteDialog: false,
    brandItem: {},
    loader: false,
    headers: [
      { text: "Brand Name", value: "Name" },
      { text: "Action", value: "action" },
      { text: "Delete", value: "deleteBrand" }
      ],
    brands: [],
  }),
  methods: {
    openDeleteModal(data) {
      this.brandItem = data;
      this.deleteDialog = true;
    },
    deleteBrand() {
      const url = `/brands/${this.brandItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.deleteDialog = false;
            self.brands = self.brands.filter((b) => b.id !== self.brandItem.id);
            self.$refs.snackbar.show("Brand deleted successfully", "green");
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created () {
    this.getBrands();
  },
};
</script>